/**
 * @flow
 * @relayHash 37e6c2e0037896c61445e8b677d5c85c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchResults_availability$ref = any;
export type InputDistributionModelType = {|
  adults: number,
  childrenAges?: ?$ReadOnlyArray<?number>,
|};
export type InputAvailabilityFilterType = {|
  hotelName?: ?string,
  categories?: ?$ReadOnlyArray<?string>,
  deals?: ?$ReadOnlyArray<?string>,
  facilities?: ?$ReadOnlyArray<?string>,
  minPrice?: ?any,
  maxPrice?: ?any,
  token?: ?string,
|};
export type SearchingWrapperQueryVariables = {|
  zoneCode?: ?string,
  hotelId?: ?string,
  language: string,
  startDate: string,
  endDate: string,
  canaryResident: boolean,
  pageSize: number,
  pageNum: number,
  order: number,
  roomsDistribution: $ReadOnlyArray<?InputDistributionModelType>,
  filter?: ?InputAvailabilityFilterType,
  channelCode: string,
  channelKey: string,
|};
export type SearchingWrapperQueryResponse = {|
  +availability: ?{|
    +$fragmentRefs: SearchResults_availability$ref
  |}
|};
export type SearchingWrapperQuery = {|
  variables: SearchingWrapperQueryVariables,
  response: SearchingWrapperQueryResponse,
|};
*/


/*
query SearchingWrapperQuery(
  $zoneCode: String
  $hotelId: String
  $language: String!
  $startDate: String!
  $endDate: String!
  $canaryResident: Boolean!
  $pageSize: Int!
  $pageNum: Int!
  $order: Int!
  $roomsDistribution: [InputDistributionModelType]!
  $filter: InputAvailabilityFilterType
  $channelCode: String!
  $channelKey: String!
) {
  availability(zoneCode: $zoneCode, hotelId: $hotelId, language: $language, startDate: $startDate, endDate: $endDate, canaryResident: $canaryResident, pageSize: $pageSize, pageNum: $pageNum, order: $order, roomsDistribution: $roomsDistribution, filter: $filter, channelCode: $channelCode, channelKey: $channelKey) {
    ...SearchResults_availability
  }
}

fragment SearchResults_availability on AvailabilityResults {
  currentPage
  order
  pageSize
  totalResults
  token
  realDistributionNumber
  facilitiesFilter {
    name
    code
    group
  }
  hotels {
    ...ResultHotel_hotel
    id
  }
}

fragment ResultHotel_hotel on AvalabilityResultsHotel {
  id
  name
  minPrice
  category
  ranking
  description
  address
  url
  photos
  latitude
  longitude
  phone
  code
  categoryName
  facilities {
    id
    className
    label
  }
  deals {
    ...ResultDeal_deal
    id
  }
  packages {
    id
    packageId
    name
    distributionId
    description
    latitude
    longitude
    price
  }
}

fragment ResultDeal_deal on AvailabilityResultHotelDeal {
  id
  code
  name
  defaultSelectionTotalPrice
  distributions {
    id
    distributionId
    name
    rooms {
      id
      roomId
      code
      name
      price
      providerName
      bookingLink
      canaryResident
      numRoomsAvailable
      roomCount
      cancellationCosts {
        cost
        date
        time
      }
      rawCancellationCosts {
        amount
        percent
        date
      }
      directPayment
      roomAdditionalInfo
      maxOccupancy
      isPVP
    }
    defaultSelectionRoom {
      id
      roomId
      roomName
      roomPrice
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "zoneCode",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hotelId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "language",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startDate",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endDate",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "canaryResident",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "pageSize",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "pageNum",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "roomsDistribution",
    "type": "[InputDistributionModelType]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filter",
    "type": "InputAvailabilityFilterType",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "channelCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "channelKey",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "canaryResident",
    "variableName": "canaryResident",
    "type": "Boolean!"
  },
  {
    "kind": "Variable",
    "name": "channelCode",
    "variableName": "channelCode",
    "type": "String!"
  },
  {
    "kind": "Variable",
    "name": "channelKey",
    "variableName": "channelKey",
    "type": "String!"
  },
  {
    "kind": "Variable",
    "name": "endDate",
    "variableName": "endDate",
    "type": "String!"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter",
    "type": "InputAvailabilityFilterType"
  },
  {
    "kind": "Variable",
    "name": "hotelId",
    "variableName": "hotelId",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language",
    "type": "String!"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order",
    "type": "Int!"
  },
  {
    "kind": "Variable",
    "name": "pageNum",
    "variableName": "pageNum",
    "type": "Int!"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "pageSize",
    "type": "Int!"
  },
  {
    "kind": "Variable",
    "name": "roomsDistribution",
    "variableName": "roomsDistribution",
    "type": "[InputDistributionModelType]!"
  },
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate",
    "type": "String!"
  },
  {
    "kind": "Variable",
    "name": "zoneCode",
    "variableName": "zoneCode",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "latitude",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "longitude",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "distributionId",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "roomId",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "date",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchingWrapperQuery",
    "type": "CanariasQuery",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "availability",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AvailabilityResults",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchResults_availability",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchingWrapperQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "availability",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "AvailabilityResults",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currentPage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "order",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "token",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "realDistributionNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "facilitiesFilter",
            "storageKey": null,
            "args": null,
            "concreteType": "FacilityFilter",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "group",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "hotels",
            "storageKey": null,
            "args": null,
            "concreteType": "AvalabilityResultsHotel",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "photos",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "minPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "category",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ranking",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "url",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "facilities",
                "storageKey": null,
                "args": null,
                "concreteType": "AvailabilityHotelInfoFacility",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "className",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "deals",
                "storageKey": null,
                "args": null,
                "concreteType": "AvailabilityResultHotelDeal",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "defaultSelectionTotalPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "distributions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AvailabilityResultHotelDistribution",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rooms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AvailabilityResultHotelRoom",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "numRoomsAvailable",
                            "args": null,
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "providerName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "bookingLink",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "canaryResident",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roomCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cancellationCosts",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AvailabilityResultHotelRoomCancellationCost",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cost",
                                "args": null,
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "time",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rawCancellationCosts",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AvailabilityResultHotelRoomRawCancellationCost",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "percent",
                                "args": null,
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "directPayment",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roomAdditionalInfo",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "maxOccupancy",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isPVP",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "defaultSelectionRoom",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AvailabilityDefaultSelectionRoom",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roomName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roomPrice",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "packages",
                "storageKey": null,
                "args": null,
                "concreteType": "AvailabilityResultHotelPackage",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "packageId",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SearchingWrapperQuery",
    "id": null,
    "text": "query SearchingWrapperQuery(\n  $zoneCode: String\n  $hotelId: String\n  $language: String!\n  $startDate: String!\n  $endDate: String!\n  $canaryResident: Boolean!\n  $pageSize: Int!\n  $pageNum: Int!\n  $order: Int!\n  $roomsDistribution: [InputDistributionModelType]!\n  $filter: InputAvailabilityFilterType\n  $channelCode: String!\n  $channelKey: String!\n) {\n  availability(zoneCode: $zoneCode, hotelId: $hotelId, language: $language, startDate: $startDate, endDate: $endDate, canaryResident: $canaryResident, pageSize: $pageSize, pageNum: $pageNum, order: $order, roomsDistribution: $roomsDistribution, filter: $filter, channelCode: $channelCode, channelKey: $channelKey) {\n    ...SearchResults_availability\n  }\n}\n\nfragment SearchResults_availability on AvailabilityResults {\n  currentPage\n  order\n  pageSize\n  totalResults\n  token\n  realDistributionNumber\n  facilitiesFilter {\n    name\n    code\n    group\n  }\n  hotels {\n    ...ResultHotel_hotel\n    id\n  }\n}\n\nfragment ResultHotel_hotel on AvalabilityResultsHotel {\n  id\n  name\n  minPrice\n  category\n  ranking\n  description\n  address\n  url\n  photos\n  latitude\n  longitude\n  phone\n  code\n  categoryName\n  facilities {\n    id\n    className\n    label\n  }\n  deals {\n    ...ResultDeal_deal\n    id\n  }\n  packages {\n    id\n    packageId\n    name\n    distributionId\n    description\n    latitude\n    longitude\n    price\n  }\n}\n\nfragment ResultDeal_deal on AvailabilityResultHotelDeal {\n  id\n  code\n  name\n  defaultSelectionTotalPrice\n  distributions {\n    id\n    distributionId\n    name\n    rooms {\n      id\n      roomId\n      code\n      name\n      price\n      providerName\n      bookingLink\n      canaryResident\n      numRoomsAvailable\n      roomCount\n      cancellationCosts {\n        cost\n        date\n        time\n      }\n      rawCancellationCosts {\n        amount\n        percent\n        date\n      }\n      directPayment\n      roomAdditionalInfo\n      maxOccupancy\n      isPVP\n    }\n    defaultSelectionRoom {\n      id\n      roomId\n      roomName\n      roomPrice\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ebeb875c57c50df124343ba948abb25c';
module.exports = node;
